import ChatFab from "../chat/ChatFab";
import { BRAND_ASSETS } from "../../brandAssets";
import { CHAT_ENABLED } from "../../api";

export const ADMIN_CHAT_STORAGE_KEY = "dashboard-admin-chat-session-id";

function AdminPanel({ currentUser, onLogout }) {
  const adminContext = {
    workspace: "Admin panel",
    userEmail: currentUser?.email,
    role: currentUser?.role,
    tools: ["user administration", "data governance", "system monitoring", "chat session review"],
  };

  return (
    <main className="admin-shell">
      <header className="admin-topbar glass-card">
        <div className="dashboard-brand-block">
          <img className="dashboard-brand-logo" src={BRAND_ASSETS.logoColor} alt="HopeCounts" />
          <div>
            <strong className="dashboard-brand-title">Suicide Prevention Dashboard Admin</strong>
            <p>Protected operations</p>
          </div>
        </div>
        <div className="admin-user-actions">
          <span className="dashboard-user-pill">{currentUser?.email}</span>
          <button type="button" className="toolbar-button toolbar-button-secondary" onClick={onLogout}>
            Logout
          </button>
        </div>
      </header>

      <section className="admin-hero fade-in-up">
        <p className="dashboard-kicker">Admin workspace</p>
        <h1 className="dashboard-title">Manage the protected side of the dashboard.</h1>
        <p className="dashboard-lede">
          This separate admin area is intentionally distinct from the public dashboard. Use it for oversight workflows, system status, and protected operations.
        </p>
      </section>

      <section className="admin-grid fade-in-up delay-1">
        <article className="glass-card admin-card">
          <span>01</span>
          <h2>User Access</h2>
          <p>Only admin accounts are enabled on the server. Ordinary user seeding and roles have been removed.</p>
        </article>
        <article className="glass-card admin-card">
          <span>02</span>
          <h2>Data Governance</h2>
          <p>Review synthetic data status, future data import jobs, and publication readiness before public display.</p>
        </article>
        <article className="glass-card admin-card">
          <span>03</span>
          <h2>System Health</h2>
          <p>Track API availability, model refresh workflows, and dashboard service checks from one place.</p>
        </article>
        <article className="glass-card admin-card">
          <span>04</span>
          <h2>Admin Assistant</h2>
          <p>{CHAT_ENABLED
            ? "The floating assistant on this page uses a separate admin chat session and is cleared on logout."
            : "The floating assistant remains visible as a coming-soon preview while live chat is disabled."}</p>
        </article>
      </section>

      <ChatFab
        context={adminContext}
        storageKey={ADMIN_CHAT_STORAGE_KEY}
        title="Admin Assistant"
        placeholder="Ask about admin operations"
        pinnedMessage="Ask about admin-level inquiries, protected workflows, user access, data governance, and system health."
        showContextInfo={false}
        enabled={CHAT_ENABLED}
      />
    </main>
  );
}

export default AdminPanel;
